import React, { useState, useEffect } from 'react';
import { IGetCategoriesShort, IGetCategoriesShortResponse } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getCategoriesShortInfoV2 } from 'backend/categories';
import FormSelect from 'components/Select/FormSelect';
import style from './ModificationDishCategorySelect.module.scss';

interface IProps {
	setModificationDishCategory: (value: Nullable<string>) => void;
	IDsSelectedRestaurant: string[];
}

export const ModificationDishCategorySelect: React.FC<IProps> = React.memo(
	({ setModificationDishCategory, IDsSelectedRestaurant }) => {
		const [isFirstRender, setIsFirstRender] = useState(true);
		const { response, loading, refetch, responseError } = useFetchData<
			IGetCategoriesShortResponse,
			IGetCategoriesShort
		>(IDsSelectedRestaurant.length ? getCategoriesShortInfoV2 : null, { restaurantIds: IDsSelectedRestaurant });

		useEffect(() => {
			if (isFirstRender) {
				setIsFirstRender(false);
			} else {
				refetch();
			}
		}, [IDsSelectedRestaurant]);

		return (
			<FormSelect
				name="selectedModificationDishCategory"
				label="categoryLabel"
				formItemClassName={style.container}
				options={response?.data.categories}
				fetchError={responseError}
				loading={loading}
				onRefetch={refetch}
				disabled={!IDsSelectedRestaurant.length || loading}
				onChange={setModificationDishCategory}
				onMouseDown={(e) => e.stopPropagation()}
				onClick={(e) => e.stopPropagation()}
			/>
		);
	},
);
